export const GENERIC_ERROR_MESSAGE = 'Something Went Wrong. Please try again later';
